import axios from "axios";
import { config } from "../utils/conf";
import { requestHeaders } from "../utils/http";

export const DEFAULT_LIMIT = 10;

export const fetchBatchOrderReportUploadsTotal = (
  customerId,
  filter,
  accessToken,
) => {
  return {
    type: "FETCH_ORDER_REPORT_UPLOADS_TOTAL",
    payload: axios.get(`${config.orderApiUrl}/v1/orders/batch`, {
      headers: requestHeaders(accessToken),
      params: {
        customerId: customerId,
      },
    }),
  };
};

export const fetchBatchOrderReportUploadsList = (
  customerId,
  filter,
  accessToken,
  offset = 0,
  limit = DEFAULT_LIMIT,
) => {
  return {
    type: "FETCH_ORDER_REPORT_UPLOADS_LIST",
    payload: axios.get(`${config.orderApiUrl}/v1/orders/batch`, {
      headers: requestHeaders(accessToken),
      params: {
        customerId: customerId,
        limit: limit,
        offset: offset,
      },
    }),
  };
};
